import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import getContext from 'recompose/getContext';
import { compose } from 'redux';
import { gifResetDone } from '../actionCreators/screen';
import ScreenImage from '../components/ScreenImage';
import { getBodyAnnotations } from '../selectors/annotation';
import { getElementHotspots, isInHandoffMode } from '../selectors/handoff';
import { getBodyHotspots } from '../selectors/hotspot';
import { getScreenStyles } from '../selectors/layout';
import { isCentredWebPrototype } from '../selectors/project';
import { getRenderedScreenDimensions, getScreen, isGIFResetRequired, } from '../selectors/screen';
function mapStateToProps(state, _a) {
    var isCurrentScreen = _a.isCurrentScreen;
    var screenStyles = getScreenStyles(state, isCurrentScreen);
    var screen = getScreen(state, isCurrentScreen);
    var hotspots = getBodyHotspots(state, screen);
    var preventScroll = !isInHandoffMode(state) && hotspots.some(function (hotspot) { return hotspot.fullScreen; });
    return {
        src: screenStyles.imgURL,
        resetGIF: isGIFResetRequired(state),
        imageMargin: screenStyles.imageMargin,
        imageWidth: screenStyles.imageWidth,
        imageHeight: preventScroll
            ? getRenderedScreenDimensions(state).height
            : screenStyles.imageHeight,
        naturalWidth: screen.img.width,
        hotspots: hotspots,
        annotations: getBodyAnnotations(state),
        elements: getElementHotspots(state),
        isCentredWebPrototype: isCentredWebPrototype(state),
        isInHandoffMode: isInHandoffMode(state),
    };
}
function mapDispatchToProps(dispatch) {
    return {
        gifResetDone: function () {
            dispatch(gifResetDone());
        },
    };
}
export default compose(getContext({ isCurrentScreen: PropTypes.bool.isRequired }), connect(mapStateToProps, mapDispatchToProps))(ScreenImage);
